import React from 'react'
import { Modal, Box } from '@mui/material'
import OneTimeServicePayment from './OneTimeServicePayment'

interface OneTimeServicePaymentModalProps {
  isOpen: boolean
  handleClose: () => void
}

const OneTimeServicePaymentModal: React.FC<OneTimeServicePaymentModalProps> = ({
  isOpen,
  handleClose,
}) => {
  return (
    <Modal open={isOpen} onClose={handleClose}>
      <>
        <Box
          sx={(theme) => ({
            background: 'white',
            zIndex: theme.zIndex.drawer + 1,
            position: 'absolute',
            top: '53%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '5px',
            display: 'flex',
            flexDirection: 'row',
            boxSizing: 'border-box',
          })}
        >
          <OneTimeServicePayment />
        </Box>
      </>
    </Modal>
  )
}

export default OneTimeServicePaymentModal
